// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2Looc","productTitle":"Footer_productTitle__2BnIO","copyright":"Footer_copyright__1BCi3"};